import React from "react";
import LabelisationHead, {
  LastLabeledByBadgeVariant,
} from "../../common/LabelisationHead";

interface VideoLabelisationHeadProps {
  currentIndex: number;
  total: number;
  nomBatch: string;
  lastLabeledBy?: string | null;
  isLabeled?: boolean;
  lastLabeledByVariant?: LastLabeledByBadgeVariant;
  onPrevious: () => void;
  onNext: () => void;
  prevDisabled: boolean;
  nextDisabled: boolean;
}

const VideoLabelisationHead = (props: VideoLabelisationHeadProps) => (
  <LabelisationHead
    itemLabel="Vidéo"
    prevTitle="Vidéo précédente"
    nextTitle="Vidéo suivante"
    {...props}
  />
);

export default VideoLabelisationHead;
